import { hsmBackendClient } from './client';
import { CreditLine, IControllerResponse } from './types';

/**
 * Cancels a company's credit line (status → inactive). Hits
 * `POST /company/{companyId}/credit-line/cancel` and returns the updated
 * `CreditLine`.
 *
 * @param companyId Target company id.
 */
export async function cancelCreditLine(companyId: string): Promise<CreditLine> {
  const response = await hsmBackendClient.post<IControllerResponse<CreditLine>>(
    `/company/${encodeURIComponent(companyId)}/credit-line/cancel`
  );

  if (!response.data.result) {
    throw new Error(
      response.data.message ?? 'Respuesta del backend sin result'
    );
  }
  return response.data.result;
}
